
import React, {useState, useEffect} from "react";
import { useInView } from 'react-intersection-observer';
import { motion } from "framer-motion";
import './progressive_background_img.css';


const placeholderVariants ={
    initial: {
      opacity: 0,
    },
    animate: {
        opacity: 1,
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 0.45,
            ease: [0.33, 1, 0.68, 1]
        }
    }
}

const fullImgVariants ={
    initial: (i) => ({
      opacity: i ? 0 : 1,
      filter: i ? 'blur(15px)' : "blur(0px)",
    }),
    animate: {
        opacity: 1,
        filter: 'blur(0px)',
        transition: {
            duration: 0.65,
            ease: [0.33, 1, 0.68, 1]
        }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 0.65,
            ease: [0.33, 1, 0.68, 1]
        }
    }
}

const ProgressiveBackgroundImg = ({ placeholderSrc, src, idx, unboundHeight = false, delay=0, forceWindowRescaling = false, forceFullWidth = false, isFirefox = false, animateIn=true, addClassNames="", thumbRefs=null, forceObjectFit=false}) => {
    const [imgSrc, setImgSrc] = useState(placeholderSrc || src);
    const [isNotDelayed, setIsNotDelayed] = useState(false);
    const { ref, inView } = useInView({
        triggerOnce: true,
        rootMargin: '0px 0px'
      });
    const [isLoaded, setIsLoaded] = useState(false)
      

    useEffect(() => {
        setTimeout(() => {
            setIsNotDelayed(true);
        }, delay);
    }, [])

    function handleScaleChange(e){
        let imgAspectRatio = e.target.width / e.target.height;
        let windowAspectratio = window.innerWidth / window.innerHeight;
        if (imgAspectRatio > windowAspectratio){
            // Image wider than window relative to height, so height needs to be 100%
            e.target.classList.add("full-height");
        } else{
            //  Image taller than window or equal, so width needs to be 100% (happens on sufficiently wide screens)
            e.target.classList.add("full-width");
        }
    }

    return (
        <div ref={ref} className={"grid-item__thumb " + addClassNames}>
            <div 
                className="refme"
                ref={el => thumbRefs ? thumbRefs.current[idx] = el : null}
            >
            <motion.div 
                initial="intial"
                animate="animate"
                variants={placeholderVariants}
                style={{
                    position: 'absolute',
                    transform: 'scale(1.05)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center',
                    width: '100%',
                    height: '100%',
                    backgroundRepeat: 'no-repeat',
                    transition: '0.5s -webkit-filter linear,0.5s transform linear',
                    opacity: '1',
                    filter: 'none',
                    transform: 'none',
                    backgroundImage: 'url('.concat(placeholderSrc,')')
                }}
            />
                <motion.img
                    key={placeholderSrc+isLoaded+isNotDelayed}
                    className={"full-thumb isL-" + isLoaded + " isND-" + isNotDelayed}
                    initial="intial"
                    layoutId={"thumb"-idx}
                    animate={isLoaded && isNotDelayed ? "animate" : "initial"}
                    variants={fullImgVariants}
                    custom={animateIn}
                    onLoad={(e) => {
                        if(forceWindowRescaling)
                            handleScaleChange(e)
                        setIsLoaded(true)
                    
                    }}
                    style={{
                        position: 'absolute',
                        width: "100%",
                        height: forceObjectFit ? "100%" : "auto",
                        objectFit: forceObjectFit ? "cover" : null
                    }}
                    src={src}
                />
            </div>
        </div>

    );
  };
  export default ProgressiveBackgroundImg;